import { Chart, registerables } from 'chart.js'
import GaugeController from '@/assets/charts/custom/GaugeController'
import StateChangeController from '@/assets/charts/custom/StateChangeController'

Chart.register(...registerables)
Chart.register(GaugeController)
Chart.register(StateChangeController)

export default Chart
